import React, { useState } from "react";
import { Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

import PageHeader from "../Layout/PageHeader";
import UserCardChargeHistory from "../User/UserCardChargeHistory";
import CardChargeFilters from "./CardChargeFilters";
import { CARD_CHARGE_PAGE_SIZE } from "../../constants/cardBinding";

const CardChargeList = () => {
  const [filters, setFilters] = useState({});

  return (
    <div>
      <PageHeader title="Card Charge" childRoutes={[{ path: "/card-charge", breadcrumbName: "Finance" }]} />

      <Collapse
        className="mb-2"
        defaultActiveKey="filters"
        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
      >
        <Collapse.Panel header="Filters" key="filters">
          <CardChargeFilters filters={filters} onFiltersChange={setFilters} />
        </Collapse.Panel>
      </Collapse>

      <UserCardChargeHistory
        allMerchants
        filters={filters}
        pageSize={CARD_CHARGE_PAGE_SIZE}
        title="All Card Charges"
      />
    </div>
  );
};

export default CardChargeList;
